import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ContactComponent } from './contact/contact.component';
import { PodComponent } from './pod/pod.component';

const routes: Routes = [
  {
    path: 'contact',
    component: ContactComponent
  },
  {
    path: 'pod',
    component: PodComponent
  }

];

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    RouterModule.forChild(routes)
  ],
  providers: [
    ],
  declarations: [
    ContactComponent,
    PodComponent,
    ]
})
export class ConnectWiseModule {
  constructor() {
  }
}
